module.exports = __webpack_public_path__ + "img/39_63.5c7e5ebf.png";